import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import axios from 'axios';
import Button from '../components/Button';
import styles from '../styles/pages/aboutuspage.module.css';
import ModalPDF from '../components/ModalPDF';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import { useAuth } from "../authentication/AuthContext";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

function AnnualReport() {
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfs, setPdfs] = useState([]);
  const [selectedPdfId, setSelectedPdfId] = useState(null);
const { isAuthenticated } = useAuth();
 
    const fetchPDFs = async () => {
      try {
        const response = await axios.get('/api/pdfs');
        setPdfs(response.data);
      } catch (err) {
        console.error("Error fetching PDFs:", err);
      }
    };

    useEffect(() => {
    fetchPDFs();
  }, []);

  const onLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1); // Reset to first page
  };

  const next = () => {
    if (pageNumber < numPages) setPageNumber(pageNumber + 1);
  };

  const prev = () => {
    if (pageNumber > 1) setPageNumber(pageNumber - 1);
  };

  const handlePDFSubmit = () => {
    // Modal already posted data; just refresh the list now
    fetchPDFs();
  };
  

  const handlePdfChange = (event) => {
    const pdfId = event.target.value;
    setSelectedPdfId(pdfId);
  };

  const openPdfInNewTab = (pdfId) => {
    window.open(`/api/pdf/${pdfId}`, '_blank');
  };

  return (
    <div className="body">
      <div className="heading">
        ANNUAL REPORTS
      </div>
      <hr />
      <hr />

      {/* Modal to add/edit PDFs */}
      {isAuthenticated  && (  
      <ModalPDF value={pdfs} onSubmit={handlePDFSubmit} />
      )}
      {/* Enhanced Dropdown to select PDF */}
      <div className="dropdown" style={{ marginBottom: '20px' }}>
        <select 
          onChange={handlePdfChange} 
          value={selectedPdfId || ''} 
          className={styles.dropdown}
        >
          <option value="">Select an Annual Report</option>
          {pdfs.map((pdf) => (
            <option key={pdf.id} value={pdf.id}>
              {pdf.description || `Annual Report ${new Date().getFullYear()}`}
            </option>
          ))}
        </select>
      </div>

      {/* Display the selected PDF's View and Download buttons */}
      {selectedPdfId && (
        <div className={styles.report} id={selectedPdfId} style={{ marginBottom: "20px" }}>
          <p>{pdfs.find(pdf => pdf.id === selectedPdfId)?.description || `Annual Report ${new Date().getFullYear()}`}</p>
          <div className={styles.buttons}>
            {/* View Button that opens PDF in a new tab */}
            <Button text="View" onClick={() => openPdfInNewTab(selectedPdfId)} />
            {/* Download Button */}
            <a href={`/api/pdf/${selectedPdfId}`} download={pdfs.find(pdf => pdf.id === selectedPdfId)?.name}>
              <Button text="Download" />
            </a>
          </div>
        </div>
      )}

      {/* Optional PDF Viewer for Direct View */}
      {/* You can uncomment this if you want an internal viewer as well */}
      {/* 
      {isPdfVisible && currentPdfBlobUrl && (
        <div className='pdf_display' style={{ marginBottom: "20px" }}>
          <div className={styles.arrow_container}>
            <FaArrowAltCircleLeft className={styles.arrow} onClick={prev} />
            <FaArrowAltCircleRight className={styles.arrow} onClick={next} />
          </div>
          <Document file={currentPdfBlobUrl} onLoadSuccess={onLoadSuccess}>
            <Page pageNumber={pageNumber} renderAnnotationLayer={false} renderTextLayer={false} />
          </Document>
          <p style={{ textAlign: "center" }}>Page {pageNumber} of {numPages}</p>
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Button text="Hide PDF" onClick={togglePdfViewer} />
          </div>
        </div>
      )}
      */}
    </div>
  );
}

export default AnnualReport;
